import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
  eventApiQueryFromSlugQuery,
  eventPublicPath,
  eventPublicSubPath,
  eventSlugQueryFromParams,
  type EventPathInput,
  type EventSlugQuery,
} from '../utils/eventSlug';

export function useEventRouteParams() {
  const params = useParams<{ organizerSlug?: string; eventSlug?: string; slug?: string }>();
  const location = useLocation();

  const query = useMemo(() => eventSlugQueryFromParams(params), [params]);
  const apiQuery = useMemo(() => eventApiQueryFromSlugQuery(query), [query]);

  return {
    params,
    location,
    query,
    apiQuery,
    isNestedRoute: query?.kind === 'nested',
    isLegacyRoute: query?.kind === 'legacy',
  };
}

export function useEventPublicPaths(event: EventPathInput | null | undefined) {
  return useMemo(() => {
    if (!event?.slug) {
      return {
        base: '/events',
        register: '/events',
        tickets: '/events',
        archive: '/events',
        paymentReturn: '/events',
        ticketsReturn: '/events',
      };
    }
    const input = {
      slug: event.slug,
      organizer_username: event.organizer_username ?? null,
    };
    return {
      base: eventPublicPath(input),
      register: eventPublicSubPath(input, 'register'),
      tickets: eventPublicSubPath(input, 'tickets'),
      archive: eventPublicSubPath(input, 'archive'),
      paymentReturn: eventPublicSubPath(input, 'payment/return'),
      ticketsReturn: eventPublicSubPath(input, 'tickets/return'),
    };
  }, [event?.slug, event?.organizer_username]);
}

export type { EventSlugQuery };
